import { useContext } from 'react';
import { primaryDimensionLengthContext } from './context';
export var usePrimaryDimensionLength = function () {
    var listLength = useContext(primaryDimensionLengthContext);
    return listLength;
};
